module.exports = "img/button-text-bold-on.32c5c21.svg";